<template>
    <svg :width="width" :height="height">
        <use :class="innerClass" :xlink:href="url"></use>
    </svg>
</template>
<script>
    export default {
        name: 'dm-icon',
        props: {
            name: {
                type: String,
                required: true
            },
            width: {
                type: Number,
                required: true
            },
            height: {
                type: Number,
                required: true
            },
            innerClass: {
                type: String,
                required: false
            },        
        },
        computed: {
            url() {
                return `/assets/symbols/icons.svg?v=${this.version}#im-${this.name}`
            },
            version() {
                return DM.Config.IconsSetVersion;
            }
        }
    };
</script>
